import { render, staticRenderFns } from "./Objeto.vue?vue&type=template&id=623e11b9&scoped=true&"
import script from "./Objeto.vue?vue&type=script&lang=js&"
export * from "./Objeto.vue?vue&type=script&lang=js&"
import style0 from "./Objeto.vue?vue&type=style&index=0&id=623e11b9&prod&lang=scss&scoped=true&"
import style1 from "./Objeto.vue?vue&type=style&index=1&id=623e11b9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623e11b9",
  null
  
)

export default component.exports